"use client"

import Tooltip from '@/ui/Tooltip'

type YearPointTooltipProps = {
  tooltipKey: string
  yearText: string
  speedupText: string
  capabilityThresholdLabel: string
  labelX?: number
  labelY?: number
  labelHitboxWidth?: number
  containerWidth?: number
  dotX?: number
  dotY?: number
  dotRadius?: number
  onEnter: () => void
  onLeave: () => void
}

export const YearPointTooltip = ({
  tooltipKey,
  labelX,
  labelY,
  labelHitboxWidth,
  containerWidth,
  dotX,
  dotY,
  dotRadius = 0,
  onEnter,
  onLeave,
}: YearPointTooltipProps) => {
  const getHitboxXStyle = (centerX: number, rawWidth: number) => {
    if (containerWidth === undefined) {
      return {
        left: centerX,
        width: rawWidth,
        transform: 'translate(-50%, -50%)',
      }
    }

    const halfWidth = rawWidth / 2
    const left = Math.max(0, centerX - halfWidth)
    const right = Math.min(containerWidth, centerX + halfWidth)
    return {
      left,
      width: Math.max(0, right - left),
      transform: 'translateY(-50%)',
    }
  }

  return (
    <>
      {labelX !== undefined && labelY !== undefined && labelHitboxWidth !== undefined && (
          <div
            className="absolute"
            style={{
              ...getHitboxXStyle(labelX, labelHitboxWidth + 40),
              top: labelY,
              height: 52,
              zIndex: 2,
              touchAction: 'pan-y',
            }}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
          />
      )}
      {dotX !== undefined && dotY !== undefined && (
          <div
            className="absolute"
            style={{
              ...getHitboxXStyle(dotX, (dotRadius * 2) + 40),
              top: dotY,
              height: (dotRadius * 2) + 40,
              zIndex: 2,
              touchAction: 'pan-y',
            }}
            onMouseEnter={onEnter}
            onMouseLeave={onLeave}
          />
      )}
    </>
  )
}
